import React from 'react'
import { Grid, Heading } from '@chakra-ui/react'
import { StockData } from '../types'
import StatCard from './StatCard'
import { formatCurrency, formatNumber, formatPercent, formatPrice } from '../utils'

interface MarketDataPanelProps {
  data: StockData
  gridTemplateColumns: number | undefined
  statCardBg: string
}

const MarketDataPanel: React.FC<MarketDataPanelProps> = ({
  data,
  gridTemplateColumns,
  statCardBg
}) => (
  <>
    <Heading as="h3" fontSize="xl" mb={4}>
      Market Data
    </Heading>
    
    <Grid
      gap={4}
      templateColumns={`repeat(${gridTemplateColumns || 1}, 1fr)`}
      width="100%"
    >
      <StatCard
        bg={statCardBg}
        label="Market Cap"
        value={formatCurrency(data.marketCap)}
        helpText="Total market value of all outstanding shares"
      />
      
      <StatCard
        bg={statCardBg}
        label="P/E Ratio"
        value={data.peRatio.toFixed(2)}
        helpText="Price to earnings ratio"
      />
      
      <StatCard
        bg={statCardBg}
        label="Volume"
        value={formatNumber(data.volume)}
        helpText="Trading volume for the day"
      />
      
      <StatCard
        bg={statCardBg}
        label="Avg. Volume"
        value={formatNumber(data.avgVolume)}
        helpText="Average daily trading volume"
      />
      
      <StatCard
        bg={statCardBg}
        label="Open"
        value={formatPrice(data.open)}
        helpText="Opening price for the day"
      />
      
      <StatCard
        bg={statCardBg}
        label="Previous Close"
        value={formatPrice(data.previousClose)}
        helpText="Previous day's closing price"
      />
      
      <StatCard
        bg={statCardBg}
        label="Day High"
        value={formatPrice(data.dayHigh)}
        helpText="Highest price of the day"
      />
      
      <StatCard
        bg={statCardBg}
        label="Day Low"
        value={formatPrice(data.dayLow)}
        helpText="Lowest price of the day"
      />
      
      <StatCard
        bg={statCardBg}
        label="52 Week High"
        value={formatPrice(data.week52High)}
        helpText="Highest price in the last 52 weeks"
      />
      
      <StatCard
        bg={statCardBg}
        label="52 Week Low"
        value={formatPrice(data.week52Low)}
        helpText="Lowest price in the last 52 weeks"
      />
      
      <StatCard
        bg={statCardBg}
        label="YTD Change"
        value={formatPercent(data.ytdChange)}
        arrowType={data.ytdChange >= 0 ? 'increase' : 'decrease'}
        helpText="Year-to-date price change percentage"
      />
      
      <StatCard
        bg={statCardBg}
        label="Beta"
        value={data.beta.toFixed(2)}
        helpText="Measure of stock volatility relative to the market"
      />
    </Grid>
  </>
)

export default MarketDataPanel
